import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

export type DialogTriggerProps = ComponentProps<typeof DialogPrimitive.Trigger>;

export const DialogTrigger = (props: DialogTriggerProps) => (
  <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />
);
